import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  signal,
  ViewChild,
} from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PlatformService } from '../../../core/services/platform.service';
import { ScrollPercent } from './scroll';

@Component({
  selector: 'app-go-top-button',
  templateUrl: './go-top.component.html',
  styleUrl: './go-top.component.scss',
  imports: [InlineSVGModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoTopComponent implements AfterViewInit {
  @ViewChild('backTopBtn') backTopBtn!: ElementRef<HTMLDivElement>;

  show = signal(false);
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private pt: PlatformService,
  ) { }

  ngAfterViewInit() {
    if (this.pt.isServer) return;
    const scroller = new ScrollPercent();

    (this.document.defaultView as Window).onscroll = (event) => {
      const percent = scroller.init();
      if (percent > 3) {
        this.show.set(true);
      } else {
        this.show.set(false);
      }
    };
  }
  goTop() {
    if (!this.pt.isServer)
      (this.document.defaultView as Window).scrollTo({ top: 0, behavior: 'smooth' });
  }
}
